export enum VipStatus {
  VipStatus_VIP_STATUS_NONE = 0, // 非VIP
  VipStatus_VIP_STATUS_REGULAR = 1, // 正式VIP
  VipStatus_VIP_STATUS_PROTECT = 2, // 保护期VIP
  VipStatus_VIP_STATUS_LOSS = 3, // 流失VIP
  VipStatus_VIP_STATUS_TRIAL = 4, // 体验期VIP
  VipStatus_VIP_STATUS_EXPIRED = 5, // 体验过期VIP
  VipStatus_VIP_STATUS_PRO = 6, // PRO用户
}
